import React from 'react'
import { Select, Tag } from 'antd'
import '../../asset/less/component.css'

const { Option } = Select

class ColorTypeSelect extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const color_array = [
      'F51836',
      'E91E63',
      'A727B0',
      '3F51B4',
      '03A7F1',
      '00BCD4',
      '00887C',
      '48A74C',
      'C1D036',
      'FFC107',
      'FF5722',
      '181818',
      'F3F1F4',
      '654321'
    ]
    let children = []
    for (let i = 0; i < color_array.length; i++) {
      children.push(
        <Option
          className={'color-option'}
          style={{ backgroundColor: '#' + color_array[i] }}
          key={color_array[i]}
          value={color_array[i]}
        ></Option>
      )
    }

    function tagRender(props) {
      const { value, closable, onClose } = props
      const onPreventMouseDown = (event) => {
        event.preventDefault()
        event.stopPropagation()
      }
      return (
        <Tag color={'#' + value} onMouseDown={onPreventMouseDown} closable={closable} onClose={onClose} style={{ marginRight: 3 }}>
          {value}
        </Tag>
      )
    }

    return (
      <Select
        placeholder='please select the color'
        {...this.props}
        allowClear
        showArrow
        tagRender={tagRender}
        style={{ width: '100%' }}
        mode='multiple'
      >
        {children}
      </Select>
    )
  }
}

export default ColorTypeSelect
